<template>
  <div class="loader"></div>
</template>

<script setup></script>

<style lang="scss" scoped>
.loader {
  position: relative;
  height: 50px;
  aspect-ratio: 1;
  margin: auto;
  &::after {
    box-sizing: border-box;
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50%;
    margin-left: -50%;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: 4px solid #000;
    border-top-color: #fff;
    animation: spin 1s linear infinite;
  }
  &-btn {
    height: 24px;
    &::after {
      border: 2px solid #000;
      border-top-color: #fff;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
